export const colors = {
    black: '#000000',
    white: '#FFFFFF',
    greyLight: '#EBEBEB',
    greyMedium: '#AEACAC',
    greyDark: '#818181',
    beige: '#EAE8E0',

    primary: '#FFE002',
    secondary: '#4A90E2',
    background: '#F1F0EB',
};
